// extracted by mini-css-extract-plugin
export default {"lesson":"Lesson_lesson__2e-8H"};